import React, { forwardRef } from 'react';
import { styled, ThemeProvider } from 'src/packages/theme';
import { compose, grid, GridProps } from 'styled-system';

import { BaseBox, BaseBoxProps } from '../$base-styled-components';

const StyledGrid = styled((props) => <BaseBox {...props} />)(
  {
    display: 'grid',
    gridAutoFlow: 'dense',
    direction: 'ltr',
  },
  compose(grid)
);

const Grid = forwardRef<HTMLDivElement, GridProps & BaseBoxProps>((props, ref) => {
  const { children, theme, ...rest } = props;

  return (
    <ThemeProvider theme={theme}>
      <StyledGrid ref={ref} {...rest}>
        {children}
      </StyledGrid>
    </ThemeProvider>
  );
});

export default Grid;
